import React, { useState } from 'react';
import './ControlNumbersModal.css';

const ControlNumbersModal = ({ lotteryLabel, products, onSave, onClose }) => {
  const [product, setProduct] = useState(products[0] || '');
  const [number, setNumber] = useState('');
  const [onlineLimit, setOnlineLimit] = useState('');
  const [localLimit, setLocalLimit] = useState('');

  const handleSave = (e) => {
    e.preventDefault();
    if (!number.trim() || !onlineLimit.trim()) return;
    onSave({ product, number: number.trim(), onlineLimit: onlineLimit.trim(), localLimit: localLimit.trim() });
    onClose();
  };

  return (
    <div className="cnm-overlay">
      <div className="cnm-modal">
        <div className="cnm-header">
          <span className="cnm-title">Controle de Numeros</span>
          <button className="cnm-close-btn" onClick={onClose}>×</button>
        </div>

        <form className="cnm-body" onSubmit={handleSave}>
          <p className="cnm-lottery-line">Loterie : {lotteryLabel}</p>

          <div className="cnm-row">
            <label className="cnm-label">Produit</label>
            <select className="cnm-select" value={product} onChange={e => setProduct(e.target.value)}>
              {products.map(p => <option key={p}>{p}</option>)}
            </select>
          </div>

          <div className="cnm-row">
            <label className="cnm-label">Numero</label>
            <input
              className="cnm-input"
              type="text"
              value={number}
              onChange={e => setNumber(e.target.value)}
              autoFocus
            />
          </div>

          <div className="cnm-row">
            <label className="cnm-label">Limite en ligne</label>
            <input
              className="cnm-input"
              type="text"
              value={onlineLimit}
              onChange={e => setOnlineLimit(e.target.value)}
            />
          </div>

          <div className="cnm-row">
            <label className="cnm-label">Limite locale</label>
            <input
              className="cnm-input"
              type="text"
              value={localLimit}
              onChange={e => setLocalLimit(e.target.value)}
              placeholder="optionnel"
            />
          </div>

          <button type="submit" className="cnm-save-btn">Sauver</button>
        </form>
      </div>
    </div>
  );
};

export default ControlNumbersModal;
